var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_6_83)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6_83",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6_83",
    transform: "scale(0.030303)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6_83",
    width: 33,
    height: 33,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAACXBIWXMAAAsTAAALEwEAmpwYAAADXElEQVRYhbXX628UVRgG8F+3W2hpsdAWNdWieCkGghpj8Bb94v/sFz97VxTrlaSxglUChVKKVNou64f3ncx03FkGs32SyTk75zLPeS/Pe3bc4aKDo9n2miaNHdLH5/AyFpIA7OAaVrF/2CSWcXbI+N/4IlswPmICp3E++338JU5/B5M4ks+T+f7hqElM4K3ccw+f4jdsYgNrmMJsEunjFqW/RoGnkwj8JE5fRR+XlW5YKgZGSeKJysfWG+b08Wf2p4RFRkqim+1DQ9JRuKpAZ9QkdrIdx/Eh82az7WO3WNAGM3g2n1Mi0ndkdCf28Vz2pwx2yQmRPWMiWK9RmrAJXVzIj9fRw69CfGALN5PkU7iIn7EtDrtYIQBXio2GiVUX7ykDjjBhfc0aVrI/ifezrZLt1NZdyQNguDsuCFEhcv2SSLFV3MN8rj+Bu0nwHE7W9qkTINzVE9ZrtMQUPszxO/jEQf8TcfJBEnkgNKIa6D3hit18P537VnETnzfFxKkKwV8GECCscRVnRKUscEMo5caAdceESL0g3L2A8SYSVcabDXOKsTPZ38N3uD5k/n0RC2t4Xrix10SiKjYTaqW3NlbgK1kLWuCBSmA2idVWpf/MkM2KsZ7hFhuKJhK38E/2l0Um1HFWXF6IejAoblqhKUX7QhEXBdElIcVHRTCdV1phF99odtkjMUwxt0SKFXVgMZ861pPI/8YgnejiFRG9ba9/94Vq3mg5f07I+hY+q1tiJgenK+/uibTbElHdESk8Ly4yXZH/F/FxzhmGCbyR7ZyaTsyIWnEkf2/jR6Fqg3A1CbyIl4RL2sTFq0odWkWvMPeEkOBjlQ+saB/x3Zz7qPlLeD37m6Ic9AtLnKsQ+B3ft/x4gTYWmBZFsZj/rchCXeGG0zm4pSzLbXESb4tC97WD17cCHREHhSSsqPzv6IgsKPBDwe4xSRTF6B1lTFWxLEo+kdJ/1BkuZP8ubj8mASJ+NrI/i3cdrKrzInAJAfyPpTtK6R50a2qDfXypzKLjIssmlek4lvtfMsBdY3hNGRPbKr5qgevysioO86a4XxK1Z0+puAeudHUSg+6FbdHDR5XfHZGC9cp7W/wtHBhv48Kc69nviFzfb/HsinSu3iH6wjr7eahi78uGaMi/cB3PKrjUYdIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.a3e89f9e8ff8189727953f4814e8cc94.svg";
export { ForwardRef as ReactComponent };